var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{staticClass:"px-0",attrs:{"app":"","dark":"","elevation":"1","height":"60","hide-on-scroll":""}},[_c('img',{staticStyle:{"width":"156px"},attrs:{"src":require("@/assets/logo_white_packhai_fulfillment.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }